import * as React from "react";
import { 
    gql, 
    useMutation, 
    ApolloError, 
    MutationTuple 
} from "@apollo/client";
import { 
    UpdateCustomerTierMutationMutation, 
    UpdateCustomerTierMutationMutationVariables 
} from "../../../../../../schemaTypes";

export const updateCustomerTierMutation = gql`
mutation UpdateCustomerTierMutation(
    $id: String!,
    $input: UpdateCustomerTierInput!
) {
    updateCustomerTier(
        id: $id,
        input: $input
    ) {
        errors {
            path
            message
        }
        message
    }
  }
`;

interface Props {
    children: (data: {
        updateCustomerTier: MutationTuple<
            UpdateCustomerTierMutationMutation,
            UpdateCustomerTierMutationMutationVariables
        >[0];
        loading: boolean;
        error?: ApolloError;
        data?: UpdateCustomerTierMutationMutation;
        errors?: { path: string; message: string }[] | null;
        message?: string | null;
    }) => React.ReactElement | null;
}

export const UpdateCustomerTierController: React.FC<Props> = ({ children }) => {
    const [
        updateCustomerTier, 
        { loading, error, data }
    ] = useMutation<
    UpdateCustomerTierMutationMutation, 
    UpdateCustomerTierMutationMutationVariables
    >(updateCustomerTierMutation);

    const errorsRaw = data?.updateCustomerTier?.errors ?? null;
    const errors = Array.isArray(errorsRaw)
        ? errorsRaw.filter((e): e is { path: string; message: string } => !!e)
        : errorsRaw;
    const message = data?.updateCustomerTier?.message ?? null;

    return children({
        updateCustomerTier,
        loading,
        error,
        data: data ?? undefined,
        errors,
        message
    });
};